let toasts = $state([]);
export function getToasts() {
  return toasts;
}
export function addToast(toast) {
  const id = crypto.randomUUID();
  const newToast = { ...toast, id };
  toasts = [...toasts, newToast];
  const duration = toast.duration ?? 5e3;
  setTimeout(() => {
    removeToast(id);
  }, duration);
}
export function removeToast(id) {
  toasts = toasts.filter((t) => t.id !== id);
}
export function clearToasts() {
  toasts = [];
}
